// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ef9e1e0c","239":"cf15efbb","455":"30518276"}[chunkId] + ".chunk.js";
};